import { useState } from 'react';
import { navLinks, siteName } from '@/mocks/home';

export default function SiteHeader() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full bg-background-50/90 backdrop-blur border-b border-background-200/70">
      <div className="flex items-center justify-between h-16 px-4 md:px-6">
        <a href="#top" className="flex items-center gap-3 shrink-0 cursor-pointer">
          <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50 text-sm font-heading font-bold">
            瓜
          </span>
          <h1 className="font-heading text-lg md:text-xl font-bold tracking-tight text-foreground-950 leading-none">
            {siteName}
            <span className="hidden sm:inline-block ml-2 align-middle text-[10px] font-body font-normal tracking-[0.24em] text-foreground-500">
              ZOOM&nbsp;ARCHIVE
            </span>
          </h1>
        </a>

        <nav className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="px-3 py-2 text-sm text-foreground-700 rounded-md hover:text-primary-600 hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#entry"
            className="hidden sm:flex items-center gap-1.5 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-zoom-in-line text-sm"></i>
            </span>
            进入放大
          </a>
          <button
            type="button"
            aria-label="展开导航"
            onClick={() => setOpen((v) => !v)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-200 text-foreground-800 cursor-pointer"
          >
            <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
          </button>
        </div>
      </div>

      {open && (
        <nav className="md:hidden border-t border-background-200/70 bg-background-50 px-4 py-3 flex flex-col gap-1">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={() => setOpen(false)}
              className="px-3 py-2.5 text-sm text-foreground-700 rounded-md hover:bg-background-100 cursor-pointer"
            >
              {link.label}
            </a>
          ))}
        </nav>
      )}
    </header>
  );
}